var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6105 1.5H3.39047C2.3356 1.5 1.48047 2.35514 1.48047 3.41V18.72C1.48047 19.7749 2.3356 20.63 3.39047 20.63H20.6105C21.6653 20.63 22.5205 19.7749 22.5205 18.72V3.41C22.5205 2.35514 21.6653 1.5 20.6105 1.5Z",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.34961 23.4989V20.6289",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6504 23.4989V20.6289",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0905 15.8491C12.7305 15.8491 14.8705 13.709 14.8705 11.0691C14.8705 8.42914 12.7305 6.28906 10.0905 6.28906C7.45063 6.28906 5.31055 8.42914 5.31055 11.0691C5.31055 13.709 7.45063 15.8491 10.0905 15.8491Z",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7402 9.15039H19.6502",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7402 12.9805H19.6502",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7402 16.8008H19.6502",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0898 4.37109V11.0711",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.34961 15.8503L10.0896 11.0703",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8298 15.8503L10.0898 11.0703",
  stroke: "#F7F7F7",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});

function SvgVault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.440b9fd40b1e87ada338e9c70afa5ecd.svg";
export { ForwardRef as ReactComponent };